import cls from 'classnames'
import React from 'react'

export type TButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  htmlType?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  loading?: boolean
  text?: string
  buttonClassName?: string
  width?: string
  height?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

export default function Button(props: TButtonProps) {
  return (
    <button
      className={cls(props.buttonClassName, {
        button__loading: props.loading,
      })}
      style={{
        ...props.style,
        width: props.width,
        height: props.height,
      }}
      disabled={props.disabled || props.loading}
      type={props.htmlType || 'button'}
      onClick={props.onClick}
    >
      {props.loading && (
        <div className="loading">
          {Array.from({ length: 8 }).map((item, index: number) => (
            <div key={index}></div>
          ))}
        </div>
      )}
      {props.text && <span className="button__text">{props.text}</span>}
      {/* TODO：Button 样式混乱，临时对齐方案，后面修复 */}
      {props.children && <div className="button__buttonContent">{props.children}</div>}
    </button>
  )
}
